import { Component, HostBinding, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-footer-actions',
    templateUrl: './footer-actions.component.html',
    styleUrls: ['./footer-actions.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class FooterActionsComponent {
  @HostBinding('class') class = 'footer';
}
